import { buildQueryParams } from 'helpers/api/build-query-params';
import type { BuildQueryParamsArgs } from 'helpers/api/build-query-params';

/**
 * Converts the legacy `buildQueryParams` URLSearchParams into a plain object
 * suitable for Orval/axios `params` (supports repeated `sort` keys).
 */
export const toQueryParamsObject = (
  args: BuildQueryParamsArgs
): Record<string, string | string[] | number> => {
  const searchParams = buildQueryParams(args);
  const result: Record<string, string | string[] | number> = {};

  searchParams.forEach((value, key) => {
    const existing = result[key];

    if (existing === undefined) {
      result[key] = key === 'page' || key === 'size' ? Number(value) : value;

      return;
    }

    if (Array.isArray(existing)) {
      existing.push(value);
    } else {
      result[key] = [String(existing), value];
    }
  });

  return result;
};
